export const DICE_TOKENS_TOTAL = 7001622;